export default __webpack_public_path__ + "static/media/yotta21_transparan__1_.eec0610f.png";